import { keycloakReducer as keycloak } from "@authzsvc/keycloak-js-react";
import { combineReducers } from "redux";
import identity from "./identity";
import loading from "./loading";
import notification from "./notification";
import application from "./application";
import applications from "./applications";
import groups from "./groups";
import resources from "./resources";
import resourceType from "./resourceType";
import userRole from "./userRole";
import requests from "./requests";
import breadcrumbs from "./breadcrumbs";
import serviceCollections from "./serviceCollections";
import serviceApplications from "./serviceApplications";
import serviceApplicationSubscription from "./serviceApplicationSubscription";
import groupsForRoles from "./groupsForRoles";
import serviceCollectionEligibilitySettings from "./serviceCollectionEligibilitySettings";
import serviceCollection from "./serviceCollection";
import serviceApplicationSubscriptionSettings from "./serviceApplicationSubscriptionSettings";
import roles from "./roles";
import searchApplications from "./searchApplications";
import managedResourceTypes from "./managedResourceTypes";
import myResourcesInManagedResourceType from "./myResourcesInManagedResourceType";
import serviceApplicationTags from "./serviceApplicationTags";
import serviceCollectionSubscription from "./serviceCollectionSubscription";
import myGroups from "./myGroups";

const rootReducer = combineReducers({
  keycloak,
  loading,
  resourceType,
  application,
  applications,
  groups,
  resources,
  identity,
  userRole,
  notification,
  requests,
  breadcrumbs,
  serviceCollections,
  serviceApplications,
  serviceApplicationSubscription,
  groupsForRoles,
  serviceCollectionEligibilitySettings,
  serviceCollection,
  serviceApplicationSubscriptionSettings,
  roles,
  searchApplications,
  managedResourceTypes,
  myResourcesInManagedResourceType,
  serviceApplicationTags,
  serviceCollectionSubscription,
  myGroups,
});

export default rootReducer;
